// extracted by mini-css-extract-plugin
export var all = "BettingFilters-module--all--3c686";
export var blue = "#0eb3f2";
export var emphasis = "BettingFilters-module--emphasis--682ce";
export var filterIcon = "BettingFilters-module--filterIcon--e3904";
export var filters = "BettingFilters-module--filters--b61cd";
export var green = "#57d33b";
export var greenLink = "BettingFilters-module--green-link--7dd64";
export var grey = "var(--tone-mid)";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var showMore = "BettingFilters-module--showMore--7f63d";
export var showMoreIcon = "BettingFilters-module--showMoreIcon--77b9d";
export var showMoreIconContainer = "BettingFilters-module--showMoreIconContainer--30fea";
export var titleFilter = "BettingFilters-module--titleFilter--c05cd";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";